var map = {
	"./Acores.svg": 4015,
	"./Alentejo.svg": 9126,
	"./Algarve.svg": 3592,
	"./AllWorld.svg": 1303,
	"./Beiras.svg": 4762,
	"./Douro.svg": 9921,
	"./Lisboa.svg": 3578,
	"./Madeira.svg": 3463,
	"./Minho.svg": 2391,
	"./Setubal.svg": 1202,
	"./Tejo.svg": 3680,
	"./map.svg": 7926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1450;